import type { TradeOpsIssuesParams, TradeOpsIssuesResponse } from 'types/models/trade-ops-issues';
import { getRequest, postRequest } from 'utils/request';

export const listTradeOpsIssues = (query: TradeOpsIssuesParams): Promise<TradeOpsIssuesResponse> =>
  getRequest(`/issues`, query);

export const archiveTradeOpsIssues = (body: { errors: string[] }): Promise<unknown> =>
  postRequest(`/issues/close`, body);

export const reopenTradeOpsIssues = (body: { errors: string[] }): Promise<unknown> =>
  postRequest(`/issues/reopen`, body);
